import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '8vh',
    background: '#C4C4C4',
    overflowX: 'hidden',
    position: 'fixed',
    marginTop: '19vh',
    zIndex: '99',
  },
  rootModal: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '8vh',
    background: '#C4C4C4',
    overflowX: 'hidden',
    zIndex: '99',
  },
  buttonSubmit: {
    cursor: 'pointer',
    width: '150px',
    backgroundColor: '#026894',
    color: '#fff',
    height: '32px',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '4px',
    textTransform: 'capitalize',
    fontSize: '14px',
    marginRight: '4%',
    '&:hover': {
      backgroundColor: '#064561',
    },
  },
  buttonExtra: {
    cursor: 'pointer',
    backgroundColor: '#026894',
    color: '#fff',
    height: '32px',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '4px',
    textTransform: 'capitalize',
    fontSize: '14px',
    marginRight: '4%',
    '&:hover': {
      backgroundColor: '#064561',
    },
  },
  button: {
    cursor: 'pointer',
    width: '25%',
    backgroundColor: '#EAEAEA',
    color: '#000000',
    height: '32px',
    boxShadow: 'none',
    border: 'none',
    textTransform: 'capitalize',
    fontSize: '14px',
    marginRight: '14%',
  },
  link: {
    color: '#000000',
    textTransform: 'capitalize',
    fontSize: '14px',
    textDecoration: 'none',
  },
  classes: {
    fontSize: '25px',
    color: '#000000',
    fontWeight: 'bold',
    marginLeft: '43%',
  },
  divButton: {
    justifyContent: 'flex-end',
    display: 'flex',
  },
  title: {
    fontSize: '22px',
    color: '#000000',
    fontWeight: 'bold',
    width: '100%',
    textAlign: 'center',
  },
}));

export default useStyles;
